import { Navigate, useNavigate } from 'react-router-dom';

export default function RestrictedRoute() {
    const navigate = useNavigate();
    return (
        <Navigate to="/" replace />
    )
}